import type { HTMLAttributes } from 'react';
import cn from 'utils/cn';

type TProps = {
  title: string;
  titleProps?: HTMLAttributes<HTMLDivElement>;
  info: string;
  infoProps?: HTMLAttributes<HTMLDivElement>;
};

const HomeContentWithoutAside = ({ title, titleProps, info, infoProps }: TProps) => {
  return (
    <>
      <div
        {...titleProps}
        className={cn(
          'tw:text-primary-100 tw:text-center tw:font-light tw:pt-8 tw:pb-1 tw:text-4xl tw:relative tw:z-1 tw:w-full',
          titleProps?.className
        )}
      >
        {title}
      </div>
      <div
        {...infoProps}
        className={cn(
          'tw:text-primary-100 tw:text-center tw:text-sm tw:relative tw:z-1',
          infoProps?.className
        )}
      >
        {info}
      </div>
    </>
  );
};

export default HomeContentWithoutAside;
